<template>
	<div>
		<div id="cower" @click="codeHide()" v-show="iscode"></div>
		<div class="tipBox" v-show="iscode">
			<h3>
				<img src="../assets/logo.png" />
			</h3>
			<p>明医智APP扫描二维码进行登录</p>
			<p style="padding-top: 20px;">
				<qriously :value="initQCode" :size="300" />
			</p>
			<h6><a href="#">没有账号？立即下载</a></h6>
		</div>
		<div class="loding" v-show="isUp"
			style="width: 100%;height: 1360px;position: absolute;top: 100px;left: 0;z-index: 9999;">
			<img src="../assets/5-121204193R5-50.gif" style="position: absolute;top: 50%;left: 55%;" />
		</div>
		<transition name="my-trans">
			<div class="helpBox" v-show="show">
				<img src="../assets/help.png" />
			</div>
		</transition>

		<div class="headers" style="position: relative;">
			<header>
				<div class="logo">
					<img src="../assets/logo.png" />
				</div>
				<ul>
					<li><router-link to="/">产品介绍</router-link></li>
					<!-- <li><router-link to="/News">新闻动态</router-link></li> -->
					<li><router-link to="/aboutUs">关于我们</router-link></li>
					<li><router-link to="/introduce">团队介绍</router-link></li>
					<li><router-link to="/contact">联系我们</router-link></li>
				</ul>
				<span class="scodes" style="min-width: 136px;" @click="codeShow(); headerShow(); openselect()"
					v-bind:style="{ fontSize: myfont }"><img v-show="header"
						style="margin-right: 10px;vertical-align: super;" :src="userimg" /><i
						style="display: inline-block;margin: 0 2px;width: 55px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap">{{
							loginTxt }}</i><img v-show="header"
						style="position: absolute;right: 10px;border-radius: 0;width: 7px;height: 7px;top: 42px;"
						src="../assets/385616900272080137.png" /></span>
				<div class="personageBox" v-show="isLogin">
					<ul>
						<router-link to="/uploadLive">
							<li>上传视频</li>
						</router-link>
						<router-link to="/openLive">
							<li>发起直播</li>
						</router-link>
						<li @click="loginOut()">退出</li>
					</ul>
				</div>
			</header>
		</div>
		<aside>
			<div class="leftBox">
				<ul>
					<li><router-link to="/uploadLive">上传视频</router-link></li>
					<li><router-link to="/openLive">发起直播</router-link></li>
				</ul>
			</div>
			<div class="rightBox">
				<ul>
					<li>
						<p>视频标题</p>
						<input type="text" placeholder="请输入标题" ref="title" />
					</li>
					<li>
						<p>视频封面</p>
						<p>
							<img style="width: 334px;height: 240px;" :src="src" />
						</p>

						<span class="choseImg">选择封面<input id="choseImgIn" type="file" accept="image/jpg"
								@change="getFile" /></span>

						<span style="font-size: 14px;color: #999999;margin-left: 10px;">图片大小2m以内，支持jpg格式</span>
					</li>
					<li>
						<p>视频文件</p>
						<h6 style="padding: 10px 0;position: relative;"><img
								style="position: absolute;left: 10px;top: 30px;" src="../assets/video.png" /><input
								style="padding-left: 50px;width: 870px;" type="text" v-model="vedioSrc" /></h6>
						<span class="choseImg">选择文件<input id="choseVedioIn" type="file" accept="video/mp4"
								@change="getVedio" /></span>

						<span style="font-size: 14px;color: #999999;margin-left: 10px;">文件大小1g以内，支持mp4格式</span>
					</li>
					<li>
						<p>视频简介</p>
						<textarea type="text" placeholder="请输视频简介" ref="profile" /></textarea>
						<p style="font-size: 14px;color: #3F3F3F;padding: 20px 0;">* 请不要上传色情、政治、宗教等敏感话题内容。详细请查看 APP的服务协议</p>
					</li>
					<!--<input type="hidden" name="url" id="url" value="" />
					<input type="hidden" name="linkurl" id="url" value="" />-->
				</ul>
				<div style="padding: 30px 0;">
					<span class="openBt" @click="postAll"> <img
							style="margin-right: 10px;margin-top: 10px;vertical-align: sub;"
							src="../assets/ups.png" />确认上传</span>
				</div>
				<div class="fottors">
					<a style="font-size: 18px;color: #666666;" href="https://www.miitbeian.gov.cn">Copyright © 2020-06-12
						eagle soar . All Rights Reserved. 京ICP备18010429号</a>
				</div>
			</div>
		</aside>
	</div>
</template>

<script>
import defaulImg from '../assets/aa.png';
import qs from 'qs';
export default {
	name: 'HelloWorld',
	data() {
		return {
			msg: 'Welcome to Your Vue.js App',
			iscode: false,
			show: false,
			isLogin: false,
			loginTxt: '扫码登陆',
			header: false,
			myfont: '20px',
			iwidth: '90px',
			file: '',
			file3: '',
			src: defaulImg,
			vedioSrc: '请选择视频',
			title: '标题',
			imgFile: '',
			vedioFile: '',
			profile: '',
			initQCode: '',
			code: '',
			urltime: '',
			token: '',
			userimg: '',
			isUp: false
		}
	},
	created: function () {
		this.headerShow();
		this.codeShow();
	},
	methods: {

		codeShow() {
			if (typeof localStorage.username != "undefined") {
				console.log(this.loginTxt)
				this.loginTxt = localStorage.username;
				this.userimg = localStorage.userimg;
				if (this.loginTxt != '扫码登陆') {
					this.myfont = '14px';
					this.iwidth = '55px';
					this.header = true;
					this.iscode = false;
					this.show = false;
					clearInterval(this.urltime);
					return
				} else {
					this.getCode();
					this.iwidth = '55px';
					this.isLogin = false;
					this.iscode = true;
					this.show = true;
					this.urltime = setInterval(() => {
						this.getLogin();
					}, 5000);
				}
			}
		},
		openselect() {
			if (this.loginTxt != '扫码登陆') {
				this.isLogin = !this.isLogin;
			} else {
				this.getCode();
				this.iwidth = '90px';
				this.isLogin = false;
				this.iscode = true;
				this.show = true;
				this.urltime = setInterval(() => {
					this.getLogin();
				}, 5000);
			}
		},
		headerShow() {
			if (this.loginTxt != '扫码登陆') {
				this.myfont = '14px';
				//this.isLogin=!this.isLogin;
				this.header = true;
			}
		},
		codeHide() {
			this.iscode = false;
			this.show = false;
			clearInterval(this.urltime);
		},
		loadingImg() {
			let formdata = new FormData();
			formdata.append('file', this.file);
			let config = {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			};
			this.$http.post('/upload/upload.do', formdata, config).then((res) => {
				console.log(res);
				if (res.status == 200) {
					this.imgFile = res.data.str;
					console.log(this.imgFile);
				}
			}).catch((error) => {
				console.log('上传图片出错了')
			});
		},

		//      loadingVedio: function() {
		//          var t = this,
		//          e = new FormData;
		//          e.append("file3", this.file3);
		//          this.$http.post("https://10.11.1.126:8080/mingyizhi/upload/uploadVideo.do", e, {
		//              headers: {
		//                  "Content-Type": "multipart/form-data"
		//              }
		//          }).then(function(e) {
		//              console.log(e),
		//             '200' == e.data.status && (t.vedioFile = e.data.str, console.log(t.vedioFile))
		//          }).
		//          catch(function(t) {
		//              console.log(t)
		//          })
		//          },
		loadingVedio() {
			this.isUp = true;
			let formdata = new FormData();
			formdata.append('file3', this.file3);
			let config = {
				headers: {
					'Content-Type': 'multipart/form-data'
				}
			};
			this.$http.post('upload/uploadVideo.do', formdata, config).then((res) => {
				console.log(res);
				if (res.status == 200) {
					this.vedioFile = res.data.str;
					this.isUp = false;
					console.log(this.vedioFile);

				}
			}).catch((error) => {
				console.log(error)
			});
		},

		openLive() {
			console.log(this.$refs.title.value);
			//return
			this.$router.push({
				path: '/OpenedLive',
				query: {
					nickNames: this.$refs.title.value
				}
			})
		},
		getFile(e) {
			let _this = this
			let files = e.target.files[0];
			_this.file = files
			console.log(_this.file)
			if (!e || !window.FileReader)
				return;
			let reader = new FileReader()
			reader.readAsDataURL(files)
			reader.onloadend = function () {
				_this.src = this.result
			}
			this.loadingImg();
		},
		getVedio(e) {
			let _this = this;
			let files = e.target.files[0];
			console.log(files.name);
			_this.file3 = files;
			_this.vedioSrc = files.name;

			console.log(_this.file3);
			this.loadingVedio();

		},
		postAll() {
			if (this.$refs.title.value != '' && this.vedioFile != '' && this.imgFile != '' && this.$refs.title.value != '') {
				let qs = require('qs');
				let data = qs.stringify({
					"name": this.$refs.title.value,
					"url": this.imgFile,
					"linkurl": this.vedioFile,
					"text": this.$refs.profile.value,
					"userid": localStorage.userid
				})
				this.$http.post('video/insertVideoPC.do', data)
					.then(function (response) {
						console.log(response);
						if (response.status == 200) {
							alert('上传成功');
							location.reload();
						}
					})
					.catch(function (error) {
						console.log(error);
						alert('上传失败');
					});
			} else {
				alert('请完善信息');
			}
		},
		getLogin() {
			console.log(11111)
			let _this = this;
			let qs = require('qs');
			let data = qs.stringify({
				"code": _this.code
			})
			this.$http.post("checkQRCode.do", data)
				.then(function (response) {
					console.log(response);
					if (response.status == 200) {
						if (response.data.data.token != '') {
							clearInterval(_this.urltime);
							_this.loginTxt = response.data.data.username;
							_this.userimg = response.data.data.img;
							localStorage.username = response.data.data.username;
							localStorage.userimg = response.data.data.img;
							localStorage.userid = response.data.data.userid;
							token = response.data.data.token;
							_this.codeShow();

						}
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		},
		getCode() {
			let _this = this;
			this.$http.get("getQR.do")
				.then(function (response) {
					console.log(response);
					if (response.status == 200) {
						_this.initQCode = response.data.data.code;
						_this.code = response.data.data.code.split("code=")[1].split("&")[0];
					}
				})
				.catch(function (error) {
					console.log(error);
				});
		}
	},
}
</script>

<style scoped>
/*头像*/
.personageBox {
	height: 254px;
	/*background: pink;*/
	width: 230px;
	position: absolute;
	right: 10px;
	background: #F9F9F9;
}

.personageBox ul {
	float: none;
	margin-left: 0;
}

.personageBox ul li {
	height: 84px;
	font-size: 20px;
	color: #999999;
	text-align: center;
	line-height: 84px;
	border-bottom: 1px solid #ECECEC;
	float: none;
}

.personageBox ul li:nth-of-type(3) {
	border: none;
}

.scodes img {
	width: 40px;
	height: 40px;
	border-radius: 50%;
	vertical-align: middle;
}

/*over*/
.choseImg {
	width: 94px;
	height: 36px;
	background-image: linear-gradient(89deg, #FCA36A 0%, #EC5E45 98%);
	border-radius: 1px;
	text-align: center;
	line-height: 36px;
	display: inline-block;
	color: #FFFFFF;
	font-size: 14px;
	font-weight: 600;
	position: relative;
}

#choseImgIn {
	width: 94px;
	height: 36px;
	position: absolute;
	left: -4px;
	opacity: 0;
}

#choseVedioIn {
	width: 94px;
	height: 36px;
	position: absolute;
	left: -4px;
	opacity: 0;
}

.my-trans-enter-active,
.my-trans-leave-active {
	transition: all .5s ease-out;
}

.my-trans-enter {
	transform: translateX(-200px);
	opacity: 0;
}

.my-trans-leave-active {
	transform: translateX(1000px);
}

.helpBox {
	/*width: 580px;*/
	/*height: 590px;*/
	position: fixed;
	z-index: 10;
	/*background: #FFFFFF;*/
	left: 72%;
	top: 50%;
	/*margin-left: -290px;*/
	margin-top: -295px;
}

html,
body {
	height: 100%;
	width: 100%;
}

#cower {
	height: 100%;
	width: 100%;
	background: rgba(0, 0, 0, 0.5);
	position: fixed;
}

.headers {
	border-bottom: 1px solid #EDEDED;
}

.tipBox {
	width: 580px;
	height: 592px;
	position: fixed;
	z-index: 10;
	background: #FFFFFF;
	left: 50%;
	top: 50%;
	margin-left: -290px;
	margin-top: -295px;
}

.tipBox h3 {
	width: 100%;
	text-align: center;
	padding: 40px 0 20px 0;
}

.tipBox p {
	font-size: 20px;
	color: #666666;
	text-align: center;
}

.tipBox p img {
	padding-top: 30px;
	width: 280px;
}

.tipBox h6 {
	font-size: 14px;
	padding-top: 20px;
	text-align: center;
}

.tipBox h6 a {
	color: #666666;
	font-weight: 400;
}

header {
	width: 1260px;
	height: 84px;
	margin: 0 auto;
	vertical-align: middle;
	padding-top: 20px;
	position: relative;
}

header img {
	width: 150px;
	height: 60px;
}

.logo {
	float: left;
}

header ul {
	float: left;
	margin-left: 120px;
}

header ul li {
	float: left;
	line-height: 60px;
	padding: 0 40px;
	font-size: 20px;
	color: #666666;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

header ul li:hover {
	color: #0075FC;
}

header ul li:nth-of-type(1) a {
	color: #0075FC;
}

.scodes {
	border-radius: 8px;
	width: 130px;
	height: 50px;
	display: inline-block;
	text-align: center;
	line-height: 50px;
	font-size: 20px;
	color: #FFFFFF;
	margin-left: 50px;
	background-image: linear-gradient(270deg, #FCA36A 0%, #EC5E45 98%);
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

aside {
	width: 1260px;
	margin: 0 auto;
	min-height: 500px;
	padding-top: 100px;
}

aside .leftBox {
	float: left;
}

aside .leftBox ul li {
	width: 230px;
	height: 84px;
	text-align: center;
	line-height: 84px;
	border: 1px solid #EBEBEB;
	font-size: 20px;

}

aside .leftBox ul li a {
	color: #999999;
}

aside .leftBox ul li:nth-of-type(1) a {
	color: #666666;
}

.rightBox {
	width: 1026px;
	min-height: 1430px;
	float: right;
	border: 1px solid #EBEBEB;
}

.rightBox dl {
	height: 140px;
	width: 920px;
	margin: 0 auto;
	padding-top: 40px;
}

.rightBox dl dt {
	float: left;
}

.rightBox dl dd {
	float: left;
}

.rightBox dl dd p {
	font-size: 18px;
	color: #666666;
	letter-spacing: -0.53px;
	line-height: 21px;
	padding-left: 30px;
}

.rightBox dl dd p:nth-of-type(1) {
	padding-bottom: 24px;
	padding-top: 24px;
}

.rightBox ul {
	width: 940px;
	padding: 10px 0;
	margin: 0 auto;
	border-bottom: 1px solid #EBEBEB;
	border-top: 1px solid #EBEBEB;
}

.rightBox ul li {
	padding: 20px 2px;
}

.rightBox ul li p {
	font-size: 20px;
	color: #666666;
	padding-bottom: 20px;
}

.rightBox ul li input {
	border: 1px solid #EBEBEB;
	width: 910px;
	height: 62px;
	padding-left: 10px;
}

.rightBox ul li textarea {
	border: 1px solid #EBEBEB;
	width: 910px;
	height: 140px;
	padding-left: 10px;
	padding-top: 10px;
	resize: none;
}

.rightBox .openBt {
	width: 260px;
	height: 80px;
	background-image: linear-gradient(270deg, #31CDF9 0%, #038CFD 98%);
	box-shadow: 0 4px 10px 0 rgba(0, 128, 254, 0.50);
	font-size: 24px;
	color: #FFFFFF;
	display: inline-block;
	text-align: center;
	line-height: 80px;
	margin-left: 44px;
	margin-right: 10px;
	border-radius: 8px;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
}

.jiaocheng {
	font-size: 14px;
	color: #FCBA4C;

}

.fottors {
	font-size: 18px;
	color: #999999;
	text-align: center;
	padding-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/pages/uploadLive.vue